// extracted by mini-css-extract-plugin
export default {"root":"qwU57Rddur","root_required":"gQj_JdcqkM","root_isEllipsed":"lxqAOxknBR"};